// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bOtT","newExpiryDate":"styles_newExpiryDate__2z9_r","footer":"styles_footer__9zk0L"};